import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase';
import './AlertBanner.css'; // Add CSS for styling the banner

const AlertBanner = () => {
    const [alertText, setAlertText] = useState('');
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const alertRef = ref(database, 'Alert'); // Reference to the Alert location in Firebase

        const unsubscribe = onValue(alertRef, (snapshot) => {
            const text = snapshot.val();
            if (text) {
                setAlertText(text);
                setVisible(true); // Show the banner if there is alert text
            } else {
                setVisible(false); // Hide the banner if there's no alert text
            }
        });

        // Clean up the listener when the component unmounts
        return () => unsubscribe();
    }, []);

    if (!visible) return null; // Don't render the component if it's not visible

    return (
        <div className="alert-banner">
            <p>{alertText}</p>
            <button onClick={() => setVisible(false)} className="close-button">
                &times;
            </button>
        </div>
    );
};

export default AlertBanner;
